import { publicCompMixin } from './publicComp';
import { createBus } from './ucBus';
import { builtinComponents, builtinFlowAtoms } from './builtin';
const __script_base__ = {
  name: 'UcRenderer',
  mixins: [publicCompMixin],
  props: {},
  data() {
    return {};
  },
  beforeCreate() {
    this.uc = createBus(this, {
      builtinAssets: {
        components: builtinComponents,
        designerComponents: [],
        flowAtoms: builtinFlowAtoms
      }
    });
    this.uc.hooks.rootBeforeCreate.call(this);
  },
  mounted() {
    const {
      renderer
    } = this.$refs;
    this.renderer = renderer;
    this.content = renderer; // alias
    this.uc.renderer = renderer;
    this.$emit('rendererMounted', renderer);
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("c-renderer", {
    ref: "renderer",
    staticClass: "uc-renderer uc-component-wrapper",
    attrs: {
      uc: _vm.uc,
      "uc-initial-pagelet": _vm.rootPagelet,
      "uc-data-sources-from-props": _vm.rootDataSources,
      "uc-internal-is-root": true
    }
  });
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "Renderer.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);